import { displayJobAttribute } from "@repo/design-system/utils/helpers";
import type { JobData, RecruiterData } from "~/types/job";

/**
 * Only the fields actually rendered, so the contact rules can be exercised
 * without standing up a whole `Job`. A real `Job` satisfies this.
 */
interface ContactJob {
  data: {
    recruiter?: JobData["recruiter"];
    recruiterData?: Pick<RecruiterData, "recruiter_mail">;
  };
}

export interface PrintviewContact {
  mail: string | null;
  name: string | null;
}

/**
 * Contact details for the printed job ad, or `null` when the job carries none.
 *
 * Hungary jobs pass through `sanitizeHungaryJob` before serialization, so this
 * returns `null` for them and the print layout omits the contact block.
 *
 * `data.recruiter` is typed `string | string[]`; indexing it directly would
 * yield the first *character* of a plain-string recruiter, hence
 * `displayJobAttribute`.
 */
export function getPrintviewContact(job: ContactJob): PrintviewContact | null {
  const name = displayJobAttribute(job.data.recruiter ?? null);
  const mail = job.data.recruiterData?.recruiter_mail;

  if (!(name || mail)) {
    return null;
  }

  return { name: name || null, mail: mail || null };
}
